import { GREEN, LIGHT_YELLOW, GRAY, ORANGE, RED } from "../config";
import { Status } from "../types";
import { SeverityType } from "../types/generic";

export const getColorByStatusCode = (code: Status): string => {
  switch (code) {
    case SeverityType.Critical:
      return RED;
    case SeverityType.Warning:
      return ORANGE;
    case SeverityType.Normal:
      return GREEN;
    case SeverityType.Mitigated:
      return LIGHT_YELLOW;
    default:
      return GRAY;
  }
};
